<template>
  <b-row>
    <b-col cols="8">
      <b-row>
        <b-col cols="12" class="container min-vh-100">
          <b-row>
            <b-overlay :show="showOverlay" rounded="sm" class="w-100">
              <b-card class="w-100 h-100">
                <ValidationObserver ref="form">
                  <b-row>
                    <b-col cols="12">
                      <h3 class="mt-3 mb-1">รับทราบเรื่อง</h3>
                    </b-col>

                    <b-col cols="12" class="mb-2">
                      <b-form-group>
                        <label for="comment"
                          >ความเห็น <span class="text-danger">*</span></label
                        >
                        <ValidationProvider
                          rules="required"
                          name="ความเห็น"
                          v-slot="{ errors }"
                        >
                          <b-form-textarea
                            v-model="sendBackData.comment"
                            rows="5"
                          ></b-form-textarea>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" class="d-flex justify-content-between">
                      <b-button variant="secondary" @click="onCancelBtnClicked">
                        ยกเลิก
                      </b-button>
                      <b-button variant="primary" @click="onSubmitBtnClicked">
                        บันทึกข้อมูล
                      </b-button>
                    </b-col>
                  </b-row>
                </ValidationObserver>
              </b-card>
            </b-overlay>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="4">
      <GccDetail :gccObj="gccDetail"> </GccDetail>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton,
  BFormRadio,
  BFormRadioGroup,
  BCard,
  BRow,
  BCol,
  BFormTextarea,
  BOverlay,
} from "bootstrap-vue";
import ClueManage from "@/views/Complaint/clue/cluemanage/ClueManage.vue";
import GccDetail from "./components/GCCDetail.vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

import * as gccStore from "@/store/api/gcc/index.js";

export default {
  components: {
    BButton,
    BFormRadio,
    BFormRadioGroup,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BOverlay,
    ClueManage,
    GccDetail,
    ValidationObserver,
    ValidationProvider,
    extend,
  },
  data() {
    return {
      gccDetail: {
        rootobject: {},
      },
      gccId: this.$route.query.id,
      sendBackData: {
        comment: "",
        type: 3, // fix ให้เป็น 3 ในหน้ารับทราบเรื่อง
      },
      sendBackOptions: [
        { text: "ขอเอกสารเพิ่มเติม", value: 1 },
        { text: "ไม่ได้อยู่ในอำนาจหน้าที่", value: 2 },
      ],
      showOverlay: false,
    };
  },
  mounted() {
    this.getGccApi();
  },
  methods: {
    getGccApi() {
      const _this = this;
      gccStore
        .getApiById(this.$route.query.id)
        .then((response) => {
          _this.gccDetail = response.data.data;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.sendBackData.gccId = _this.$route.query.id;

            _this.showOverlay = true;

            gccStore
              .sendBack(_this.sendBackData)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "GCC",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              })
              .then(() => {
                _this.showOverlay = false;
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(this.$router.resolve({ name: "GCC" }).href, "_self");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
